export default __webpack_public_path__ + "static/media/smoke_2.104111ee.png";